import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

import getCoreHistoryStore from "../../../stores/core/core-history-store";
import AdminUsageData from "./admin-usage-data";
import AdminUsageForm from "./admin-usage-form";

const AdminUsage = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_ADMIN_USAGE_DATA",
      "DEVELOPER_ADMIN_USAGE_DATA"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ADMIN_USAGE_DATA")}
        subTitle={i18n.get("ADMIN_USAGE_DATA")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <AdminUsageForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AdminUsageData />
    </ET3PageDiv>
  );
});

export default AdminUsage;
